import * as $ from 'jquery';
import { BaseEngine } from './baseEngine.js';

export class Connect extends BaseEngine {
  _widthItem;
  _heightItem;
  _rows;
  _cols;
  _colorBgrTarget;
  _freeDrawing;
  _hideLine;

  constructor() {
    super({ engine: 'connect' });
    this.layout.otherProperty = {
      lines: {
        good: {
          hideLine: true,
          color: 'green',
        },
        connect: {
          color: 'black',
          hideLine: true,
        },
        select: {
          color: 'black',
          hideLine: true,
        },
      },
      points: {
        pointMouse: {
          color: 'rgba(0,0,0,0.3)',
          rad: 11,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          color: 'rgba(0,0,0,0.8)',
          positions: {
            pos: { setTo: 'center' },
            rad: 11,
          },
        },
        items: [{ id: 'p01' }],
      },
    };
    this.freeDrawing = false;
    this.hideLine = false;

    if (this.withoutCheck === true) {
      this.rulesGame.itemsGarbage = [];
      this.rulesGame.itemsConfig = { block: false };
      this.rulesGame.items = [];
    }
  }

  set freeDrawing(val) {
    this._freeDrawing = val;
    this.layout.otherProperty.lines.freeDrawing = this._freeDrawing;
  }
  get freeDrawing() {
    return this._freeDrawing;
  }
  set hideLine(val) {
    this._hideLine = val;
    this.layout.otherProperty.lines.hideLine = this._hideLine;
  }
  get hideLine() {
    return this._hideLine;
  }
}
